'use client';

import React from 'react';
import Image from 'next/image';

const Footer = (props) => {
  const { dict } = props;

  return (
    <footer className='relative bg-dark-navy/10 backdrop-blur-sm border-t border-gray-600 py-16 px-4'>
      <div className='max-w-7xl mx-auto flex items-center justify-between'>
        {/* Logo */}
        <div className='flex items-center space-x-2'>
          <Image
            src='./images/img_group_39969.svg'
            alt='Green Energy LV Logo'
            width={46}
            height={41}
          />
          <Image
            src='./images/img_group_39981.svg'
            alt='Green Energy LV Text'
            width={125}
            height={41}
          />
        </div>

        {/* Copyright */}
        <p className='text-lg font-montserrat text-white text-center'>
          © 2025 Green Energy LV. {dict.copyright}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
